// A portrait is either a real photo of that person or their initials on
// their own colour, never a stand-in (spec section 7).
import { artImg } from "../assets.js";

export interface AvatarSubject {
  name: string;
  photo?: string | null;
  photoPos?: string | null;
  initials?: string | null;
  color?: string | null;
}

// `title` names the person on hover where the card does not spell them out
// (29 Jul 2026): a portrait with no caption is a face and nothing else.
export function Avatar({ e, size = "m", title }: {
  e: AvatarSubject;
  size?: "xs" | "s" | "m" | "l";
  title?: string;
}) {
  if (e.photo) {
    return (
      <img
        className={`av ${size}`}
        {...artImg(e.photo)}
        /* 64px is the largest an avatar draws (.av.l), so the browser takes
           the 128 variant at 1x and the 256 at 2x, and the 800px original sits
           on the bucket for whatever wants it later (3 Aug 2026). */
        sizes="64px"
        style={{ objectPosition: e.photoPos ?? "50% 30%" }}
        alt=""
        title={title}
        loading="lazy"
      />
    );
  }
  return (
    <span className={`av ${size}`} style={{ background: e.color ?? "#5A5F72" }} title={title}>
      {e.initials ?? "??"}
    </span>
  );
}

// Name plus the person's own title for a hover label: the full role
// record, not the trimmed display line, because a tooltip has the room.
export function avatarTitle(e: { name?: string | null; role?: string | null; lens?: string | null }): string {
  return [e.name, e.role ?? e.lens].filter(Boolean).join(" · ");
}
